import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { MarkupActionSphereViewer } from "@pages/project-details/project-markups/markup-action-sphere-viewer";
import { MarkupActionShareMarkup } from "@pages/project-details/project-markups/markup-action-share-markup";
import { MarkupNameAndDetails } from "@pages/project-details/project-markups/markup-name-and-details";
import { MarkupSidePanelLocation } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-location";
import { MarkupSidePanelNavigation } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-navigation";
import { MarkupSidePanelTags } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-tags";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { CloseIcon, useToast } from "@flat-ui";
export function MarkupsSidePanelHeader(t0) {
  const $ = _c(37);
  const {
    markup,
    markups,
    closeSidePanel,
    viewerHref,
    isLoading: t1,
    placeId
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const {
    isMarkupUpdateInProgress
  } = useMarkupContext();
  const {
    openToast
  } = useToast();
  let t2;
  if ($[0] !== closeSidePanel || $[1] !== isMarkupUpdateInProgress || $[2] !== openToast) {
    t2 = function onCloseClick() {
      if (isMarkupUpdateInProgress()) {
        openToast({
          title: "Cannot close sidebar",
          message: "An update is in progress. Please wait until it is complete.",
          variant: "warning"
        });
        return;
      }
      closeSidePanel();
    };
    $[0] = closeSidePanel;
    $[1] = isMarkupUpdateInProgress;
    $[2] = openToast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onCloseClick = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: 1
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      gap: 1
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== markup || $[7] !== markups) {
    t5 = markups && <MarkupSidePanelNavigation markup={markup} markups={markups} />;
    $[6] = markup;
    $[7] = markups;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ml: "auto",
      gap: 1,
      alignItems: "center"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== markup || $[11] !== viewerHref) {
    t7 = <MarkupActionSphereViewer markup={markup} isLabeled={true} viewerHref={viewerHref} />;
    $[10] = markup;
    $[11] = viewerHref;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== markup) {
    t8 = <MarkupActionShareMarkup markup={markup} />;
    $[13] = markup;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== onCloseClick) {
    t9 = <SphereIconButton onClick={onCloseClick} component={CloseIcon} buttonSize="30px" dataTestId="markup-side-panel-close-button" />;
    $[15] = onCloseClick;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Stack direction="row" sx={t6}>{t7}{t8}{t9}</Stack>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5) {
    t11 = <Stack direction="row" sx={t4}>{t5}{t10}</Stack>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== markup) {
    t12 = <MarkupNameAndDetails markup={markup} isSidePanelOpen={true} />;
    $[24] = markup;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isLoading || $[27] !== markup || $[28] !== placeId) {
    t13 = <MarkupSidePanelLocation markup={markup} isLoading={isLoading} placeId={placeId} />;
    $[26] = isLoading;
    $[27] = markup;
    $[28] = placeId;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== markup.labels) {
    t14 = <MarkupSidePanelTags labels={markup.labels} />;
    $[30] = markup.labels;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t15 = <Stack sx={t3}>{t11}{t12}{t13}{t14}</Stack>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}